import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-facebook',
  templateUrl: './facebook.component.html',
  styleUrls: ['./facebook.component.scss']
})
export class FacebookComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
